import './Skeleton.css'

/**
 * A placeholder in the shape of the content that is coming.
 *
 * @param {'text'|'circle'|'block'} [variant]
 * @param {string} [width]  any CSS length; defaults to filling the inline axis
 */
export default function Skeleton({ variant = 'block', width, height, className = '' }) {
  return (
    <span
      className={`skeleton skeleton--${variant} ${className}`.trim()}
      style={{ width, height }}
      aria-hidden="true"
    />
  )
}

/**
 * A table body's worth of placeholder rows.
 *
 * Widths vary per column so the block reads as text of different lengths rather
 * than as a grid of identical bars — the varied one is what makes a skeleton
 * look like a list instead of a loading graphic. The pattern is deterministic,
 * so it does not reshuffle on every render.
 */
const WIDTHS = ['70%', '52%', '84%', '46%', '63%', '75%', '55%']

export function SkeletonRows({ columns, rows = 6 }) {
  return (
    <tbody className="skeleton-rows" aria-hidden="true" data-testid="table-skeleton">
      {Array.from({ length: rows }, (_, row) => (
        <tr key={row}>
          {Array.from({ length: columns }, (_, column) => (
            <td key={column} className="skeleton-rows__cell">
              <Skeleton variant="text" width={WIDTHS[(row + column) % WIDTHS.length]} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}
